import api from '.';

export const sendPasswordResetCode = async (email: string) => {
  const { data } = await api.post('/email/sendVerification', { email });
  return data;
};

export const verifyAccount = async (email: string, code: string) => {
  const { data } = await api.post('/account/verifyAccount', { email, code });
  return data;
};

export const updatePassword = async (
  code: string,
  password: string,
  email: string
) => {
  const { data } = await api.post('/account/updateUserPassword', {
    code,
    password,
    email,
  });
  return data;
};
